
import React, { useState } from "react";
import axios from "axios"
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css'
import QueriesHeader from "./QueriesHeader";
import queryString from 'query-string'



export default function NewModuleContactForm({ hideQueries }) {
  const [values, setValues] = useState({ username: null, password: null, error: false, success: false });
  const [appNames, setAppNames] = useState([])
  const [externalAppName, setExternalAppName] = useState('')
  const [defaultUsername, setDefaultUsername] = useState('')
  const [queries, setQueries] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const [isGettedApps, setIsGettedApps] = useState(false)

  React.useEffect(() => {
    // let res = decryptResponse(localStorage.getItem('nigol'))
    const parsed = queryString.parse(window.location.search);
    // console.log(parsed)
    if (parsed.appName) {
      if (localStorage.getItem('appInfo')) {
        // setAppInfo(JSON.parse(localStorage.getItem('appInfo')))
      } else {
        // setAppInfo(parsed)
        localStorage.setItem('appInfo', JSON.stringify(parsed))
      }
    }
    const uuid = localStorage.getItem("uuid")
    console.log(uuid)
    if (uuid) {
      setValues({ id: uuid, name: values.name })
      console.log(uuid); // This is the pseudo-unique browser identifier
      getQueriesByUser({ id: uuid })
    } else {
      const fpPromise = FingerprintJS.load();
      fpPromise.then(fp => {
        fp.get().then(result => {
          localStorage.setItem("uuid", result.visitorId)
          setValues({ id: result.visitorId, name: values.name })
          console.log(result.visitorId); // This is the pseudo-unique browser identifier
          getQueriesByUser({ id: result.visitorId })
        });
      });
    }
    if (true)
      getAppNames()

  }, []);
  React.useEffect(() => {
    if (isGettedApps) {
      const parsed = queryString.parse(window.location.search);
      console.log(parsed)
      if (parsed.appName) {
        setExternalAppName(parsed.appName)
        setDefaultUsername(parsed.username)
        setValues({ id: values.id, name: parsed.username })
      }
    }
  }, [isGettedApps])

  // 


  const getAppNames = () => {
    console.log(`appNames`)
    axios.get('https://givvy-general-payment.herokuapp.com/getAllAppsSchemaForAdminPanel').then(res => {
      let appsCurr = [{ appName: "genericQuestion", realName: 'Generic Question' }, ...res.data.appObjects1]
      setAppNames(appsCurr)
      // if (!isGettedApps) {
      setIsGettedApps(true)
      // }
    })
  }

  const getQueriesByUser = (res) => {
    //console.log(res)
    setIsLoading(true)
    axios.post('https://givvy-backend-site.herokuapp.com/getQueriesByUser', { userId: res.id }).then((res) => {
      setQueries(res.data.result)
      setIsLoading(false)
    })
  }
  return (
    <QueriesHeader hideQueries={hideQueries} currQueries={queries} userId={values.id} isLoading={isLoading}></QueriesHeader>
  )

}

